export function ensureShopwareValidUrl (url?: string): string {
  const urlTrimmed = url?.trim() || ''
  if (urlTrimmed[urlTrimmed.length - 1] === '/') return urlTrimmed.substring(0, urlTrimmed.length - 1)

  return urlTrimmed || ''
}
